'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

let UI_STATE = /*#__PURE__*/function (UI_STATE) {
  UI_STATE[UI_STATE["OPT_IN"] = 0] = "OPT_IN";
  UI_STATE[UI_STATE["SUBSCRIBED"] = 1] = "SUBSCRIBED";
  UI_STATE[UI_STATE["UNSUBSCRIBED"] = 2] = "UNSUBSCRIBED";
  UI_STATE[UI_STATE["ERROR_API"] = 3] = "ERROR_API";
  UI_STATE[UI_STATE["ERROR_VALIDATION"] = 4] = "ERROR_VALIDATION";
  UI_STATE[UI_STATE["CPREF_CONFIRM"] = 5] = "CPREF_CONFIRM";
  UI_STATE[UI_STATE["CPREF_SUBSCRIBED"] = 6] = "CPREF_SUBSCRIBED";
  UI_STATE[UI_STATE["CPREF_UNSUBSCRIBED"] = 7] = "CPREF_UNSUBSCRIBED";
  UI_STATE[UI_STATE["CPREF_MARKETING"] = 8] = "CPREF_MARKETING";
  return UI_STATE;
}({});
let Channels = /*#__PURE__*/function (Channels) {
  Channels["SMS"] = "sms";
  Channels["EMAIL"] = "email";
  Channels["HIPAA_SMS"] = "hipaa_sms";
  Channels["HIPAA_EMAIL"] = "hipaa_email";
  Channels["APP_PUSH"] = "app_push";
  Channels["LINE"] = "line";
  Channels["SUBLIME"] = "sublime";
  return Channels;
}({});
let PreferenceLevels = /*#__PURE__*/function (PreferenceLevels) {
  PreferenceLevels["TRACKING"] = "TRACKING";
  PreferenceLevels["ORDER"] = "ORDER";
  PreferenceLevels["RETAILER"] = "RETAILER";
  PreferenceLevels["ORDER_ONLY"] = "ORDER_ONLY";
  return PreferenceLevels;
}({});

exports.Channels = Channels;
exports.PreferenceLevels = PreferenceLevels;
exports.UI_STATE = UI_STATE;
